export default __webpack_public_path__ + "static/media/element_spec_68.dcad6981.webp";